import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

type Status = "idle" | "sending" | "ok" | "error";

export function KalenderForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [errorMsg, setErrorMsg] = useState("");

  async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = Object.fromEntries(new FormData(form));
    setStatus("sending");
    setErrorMsg("");
    try {
      const res = await fetch("/api/kalender", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok || !json.ok) throw new Error(json.error || "send_failed");
      setStatus("ok");
      form.reset();
    } catch (err: unknown) {
      setStatus("error");
      setErrorMsg(err instanceof Error ? err.message : "send_failed");
    }
  }

  if (status === "ok") {
    return (
      <div className="rounded-2xl border border-primary/30 bg-primary/10 p-6 text-foreground">
        <p className="font-semibold">Tak for din bestilling!</p>
        <p className="mt-2 text-foreground/85">
          Vi har modtaget din henvendelse og sender kalenderen afsted hurtigst muligt.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={onSubmit} className="grid gap-4 sm:grid-cols-2">
      {/* honeypot */}
      <input
        type="text"
        name="company_url"
        tabIndex={-1}
        autoComplete="off"
        className="hidden"
        aria-hidden="true"
      />

      <div className="sm:col-span-1">
        <Label htmlFor="kf-navn">Navn*</Label>
        <Input id="kf-navn" name="navn" required maxLength={200} className="mt-1" />
      </div>
      <div className="sm:col-span-1">
        <Label htmlFor="kf-firma">Firmanavn</Label>
        <Input id="kf-firma" name="firma" maxLength={200} className="mt-1" />
      </div>

      <div className="sm:col-span-2">
        <Label htmlFor="kf-adresse">Adresse*</Label>
        <Input id="kf-adresse" name="adresse" required maxLength={300} className="mt-1" />
      </div>

      <div className="sm:col-span-1">
        <Label htmlFor="kf-postnr">Postnummer*</Label>
        <Input id="kf-postnr" name="postnr" required maxLength={20} className="mt-1" />
      </div>
      <div className="sm:col-span-1">
        <Label htmlFor="kf-by">By*</Label>
        <Input id="kf-by" name="by" required maxLength={100} className="mt-1" />
      </div>

      <div className="sm:col-span-2">
        <Label htmlFor="kf-email">Email*</Label>
        <Input id="kf-email" name="email" type="email" required maxLength={200} className="mt-1" />
      </div>

      <div className="sm:col-span-2">
        <Label htmlFor="kf-besked">Evt. besked</Label>
        <Textarea id="kf-besked" name="besked" rows={4} maxLength={5000} className="mt-1" />
      </div>

      <div className="sm:col-span-2 flex flex-col gap-3">
        <button
          type="submit"
          disabled={status === "sending"}
          className="btn-cta self-start disabled:opacity-60"
        >
          {status === "sending" ? "Sender…" : "Send"}
        </button>
        {status === "error" && (
          <p className="text-sm text-destructive">
            Noget gik galt ({errorMsg}). Prøv igen, eller skriv til info@misupport.dk.
          </p>
        )}
        <p className="text-xs text-foreground/60">
          Ved at udfylde formen ovenfor accepteres vores persondatapolitik og at vi må sende dig
          information fremover.
        </p>
      </div>
    </form>
  );
}